import { useMemo } from 'react';

import useBuilderCategoryNav from '~/grid/components/categoryNav/utils/useBuilderCategoryNav';

const useTabsAndBreadcrumbs = () => {
  const { builderJson, isLoading } = useBuilderCategoryNav();

  const urlToTabsAndBreadcrumbsMap = useMemo(() => {
    const map = new Map();
    const topLevelTabs = builderJson?.data?.blocks;

    if (!topLevelTabs) {
      return map;
    }

    topLevelTabs.forEach((T1Block) => {
      const T1LinkText = T1Block?.component?.options?.linkText;

      if (!T1Block.children) {
        return;
      }

      T1Block.children.forEach((T2Block) => {
        const T2LinkPath = T2Block?.component?.options?.linkPath;
        const T2LinkText = T2Block?.component?.options?.linkText;
        const T2LinkTextOverride =
          T2Block?.component?.options?.linkTextOverride;
        const T2Tab = {
          label: T2LinkText,
          labelOverride: T2LinkTextOverride,
          urlPath: T2LinkPath,
        };

        if (!T2Block.children) {
          return;
        }

        const T3Tabs = T2Block?.children?.map((T3Block) => ({
          label: T3Block?.component?.options?.linkText,
          labelOverride: T3Block?.component?.options?.linkTextOverride,
          urlPath: T3Block?.component?.options?.linkPath,
        }));

        T3Tabs.forEach((T3Tab) => {
          const T3LinkPath = T3Tab.urlPath;
          const T3LinkText = T3Tab.label;
          const T3LinkTextOverride = T3Tab.labelOverride;

          map.set(T3LinkPath, {
            activeTab: {
              label: T3LinkText,
              labelOverride: T3LinkTextOverride,
              urlPath: T3LinkPath,
            },
            tabs: [T2Tab, ...T3Tabs],
            breadcrumbs: [T1LinkText, T2LinkText, T3LinkText],
          });

          map.set(T2LinkPath, {
            activeTab: T2Tab,
            tabs: [T2Tab, ...T3Tabs],
            breadcrumbs: [T1LinkText, T2LinkText],
          });
        });
      });
    });

    return map;
  }, [builderJson]);

  const topLevelTabs = builderJson?.data?.blocks;

  if (!topLevelTabs) {
    return {
      activeTab: null,
      tabs: [],
      breadcrumbs: [],
      isLoading,
    };
  }

  const currentTabsAndBreadcrumbs = urlToTabsAndBreadcrumbsMap.get(
    window?.location?.pathname
  );

  return {
    ...currentTabsAndBreadcrumbs,
    isLoading,
    urlToTabsAndBreadcrumbsMap,
  };
};

export default useTabsAndBreadcrumbs;
